import { Component, Injector,EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileUploader, FileUploaderOptions, FileItem } from 'ng2-file-upload';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ProfileServiceProxy } from '@shared/service-proxies/service-proxies';
import { IAjaxResponse, TokenService } from '@node_modules/abp-ng2-module';
import { AppConsts } from '@shared/AppConsts';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
@Component({
    selector: 'file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent extends AppComponentBase implements OnInit {
    @Input() data: string;
    @Input() isPrivate: boolean;
    @Output() dataChange = new EventEmitter();
  public uploader: FileUploader;
  private _uploaderOptions: FileUploaderOptions = {};
    canDisplayPreview: boolean;
  description: string;

  constructor(injector: Injector, private _tokenService: TokenService, private _httpClient: HttpClient,) {
      super(injector);
  }




  ngOnInit() {
      this.initFileUploader();
  }

  initFileUploader(): void {
        this.canDisplayPreview = this.data && this.data.length>0;
        var url = this.isPrivate?'/FileUpload/PrivateUploadFile':'/FileUpload/UploadFile';
      this.uploader = new FileUploader({ url: AppConsts.remoteServiceBaseUrl + url });
      this._uploaderOptions.autoUpload = false;
      this._uploaderOptions.authToken = 'Bearer ' + this._tokenService.getToken();
      this._uploaderOptions.removeAfterUpload = true;
      this.uploader.onAfterAddingFile = (file) => {
          file.withCredentials = false;
      };

      this.uploader.onBuildItemForm = (fileItem: FileItem, form: any) => {
          form.append('Description', this.description);
      };

      this.uploader.onSuccessItem = (item, response, status) => {
          const resp = <IAjaxResponse>JSON.parse(response);
          if (resp.success) {
            debugger;
            this.data= resp.result;
            this.canDisplayPreview = this.data && this.data.length>0;
                this.dataChange.emit(this.data);
              this.message.success(this.l('FileSavedSuccessfully', response));
          } else {
              this.message.error(resp.error.message);
          }
      };

      this.uploader.setOptions(this._uploaderOptions);
  }

  save(): void {
      this.uploader.uploadAll();
  }

  fileChangeEvent(event: any): void {
      this.uploader.clearQueue();
      this.uploader.addToQueue([event.target.files[0]]);
  }
  clearData():void{
    this.data= null;
    this.canDisplayPreview = this.data && this.data.length>0;
    this.dataChange.emit(this.canDisplayPreview);
    this.dataChange.emit(this.data);
  }
  previewByData(event: any):void{
    if(!this.isPrivate){
        window.open(this.data);
    } else{
        const headers = new HttpHeaders().set('authorization','Bearer '+this._tokenService.getToken());
        this._httpClient.get(this.data,{headers, responseType: 'blob' as 'json'}).subscribe(
            (response: any) =>{
                let filename = this.data.split('/').pop()
                let dataType = response.type;
                let binaryData = [];
                binaryData.push(response);
                let fileUrl = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
                window.open(fileUrl);

                /// for download file
                // let downloadLink = document.createElement('a');
                // downloadLink.href =fileUrl ;
                // if (filename)
                //     downloadLink.setAttribute('download', filename);
                // document.body.appendChild(downloadLink);
                // downloadLink.click();
            }
        )
    }
    
  }
}